import { Component } from "solid-js";
import { Img } from "../universal/image";
import { Artwork } from "../../types";
import { createSocialShare, FACEBOOK } from "@solid-primitives/share";
import { cleanImagePath } from "../../api";
import "./index.css";

type Props = {
    artwork: Artwork;
}

export const FacebookShareButton : Component<Props> = ({ artwork }) => {
    const shareClicked = (e: Event) => {
        e.preventDefault();
        const media = `https://www.artrenewal.org${cleanImagePath(artwork.primaryImage.url)}?mode=crop&maxWidth=1000&maxHeight=1000`;
        const [share, close] = createSocialShare(() => ({
            title: `${artwork.title} by ${artwork.artist.firstName} ${artwork.artist.lastName}`,
            url: window.location.href,
            description: artwork.content || "",
            media
        }));
        share(FACEBOOK);
    }
    return (
        <>
            <span style="position: relative; top: -3px;" onClick={shareClicked}>
                <Img src={"/Images/icons/facebook_circle_color-256.png"} style="height: 1em; width: auto;" />
            </span>
        </>
    );
}